var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_vm._t("default"),_vm._l((_vm.extend),function(item,index){return _c(item.component,_vm._b({key:index,tag:"component"},'component',_vm.bindProperties,false))})],2)}
var staticRenderFns = []

export { render, staticRenderFns }